var _defs, _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzienda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.09 56.34",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.48 35.62 61.09 46.91 56.48 44.23 51.87 46.91 56.48 35.62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.87 56.34 1.87 29.01 6.41 29.01 6.41 51.79 54.21 51.79 54.21 44.58 58.75 44.58 58.75 56.34 1.87 56.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.24,12.33v-4.78c0-1.66-1.35-3.01-3.01-3.01h-15.84c-1.66,0-3.01,1.35-3.01,3.01v4.78h-4.54v-4.78c0-4.16,3.39-7.55,7.55-7.55h15.84c4.16,0,7.55,3.39,7.55,7.55v4.78h-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.3,35.46v-2.75l18.78-6.26c.6-.2,1-.76,1-1.39v-9.99H4.54v9.99c0,.63.4,1.19,1,1.39l18.78,6.37v1.61l-.97,2.85-19.26-6.53c-2.45-.81-4.1-3.1-4.1-5.69v-14.53h60.62v14.53c0,2.59-1.65,4.88-4.11,5.7l-19.6,6.54-.61-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.56,44.11v-15.51h15.51v15.51h-15.51Zm4.54-4.54h6.43v-6.43h-6.43v6.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzienda);
export default __webpack_public_path__ + "static/media/azienda.055fb601ea9944da295e15f491b70477.svg";
export { ForwardRef as ReactComponent };